/* KOMTO cart drawer add-ons: one tap adds the accessory, then the theme re-renders the drawer. */
(function () {
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-komto-addon-add]');
    if (!btn) return;
    var card = btn.closest('.komto-cart-addon');
    var id = card && card.dataset.variantId;
    if (!id) return;
    btn.disabled = true;
    try {
      var r = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });
      if (!r.ok) throw new Error('add failed');
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    } catch (err) {
      btn.disabled = false;
    }
  });
})();
